/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateCompetenceLangRequestViewModel } from "../types/UpdateCompetenceLangRequestViewModel.ts";

export const updateCompetenceLangRequestViewModelSchema = z.object({
  cultureInfo: z
    .string()
    .describe("Código do idioma (cultura) da tradução.")
    .nullish(),
  name: z.string().describe("Nome da competência neste idioma.").nullish(),
  description: z
    .string()
    .describe("Descrição da competência neste idioma. Opcional.")
    .nullish(),
}) as unknown as ToZod<UpdateCompetenceLangRequestViewModel>;
